import React from 'react';
import '@/components/Interstitial.css';

interface ShareIntroBlockProps {
  /** The type's message substitution, e.g. `rally`. */
  topicType: string;
  /** The `?f=` display name of whoever shared the link, when they allowed one. */
  senderName?: string;
  /** Arrived via an update leg (#427) — the sender shared an update, not the topic. */
  isUpdate?: boolean;
}

/**
 * The opening line of a welcome sheet: who shared this topic, and what Snowball
 * is. The standard intro every type shows unless it has a fuller story to tell.
 */
const ShareIntroBlock: React.FC<ShareIntroBlockProps> = ({
  topicType,
  senderName,
  isUpdate = false,
}) => {
  // "_" is the anonymous-sender sentinel the _topicUrl token writes.
  const displayName =
    senderName && senderName !== '_' ? senderName : 'A contact';

  return (
    <p className="interstitial__message">
      <strong>{displayName}</strong> shared{' '}
      {isUpdate ? 'an update to this' : 'this'} {topicType} through Snowball, a
      web app that makes it easy to spread the word.
    </p>
  );
};

export default ShareIntroBlock;
